/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export enum Dual {
  yes = "yes",
  no = "no",
}

export enum StoreModelType {
  integrated = "Integrated",
  concierge = "Concierge",
  integratedPartner = "Integrated Partner",
}

export enum TransactionCategory {
  orderValue = "Mex Order Value",
  orderValueTax = "Mex Order Value Tax",
  coFund = "Mex Co-Fund",
  commission = "Mex Commission",
  commissionTax = "Mex Commission Tax",
  compensationOrderTax = "Mex Compensation - Orders Tax",
  compensationCommission = "Mex Compensation - Commission",
  compensationOrders = "Mex Compensation - Orders",
  compensationDeliveryFee = "Mex Compensation - Delivery Fee",
  compensationCommissionTax = "Mex Compensation - Commission Tax",
  wrongPayeeAdjustments = "Mex Wrong Payee Adjustments",
  activationFee = "Mex Activation Fee",
  commissionHoliday = "Mex Commission Holiday",
  dataFee = "Mex Data Fee",
  otherIncome = "Mex Other Income",
  deviceSetup = "Mex POSM Setup",
  devicePayment = "Mex OEM Payment",
  withholdingTax = "Mex Withholding Tax Refund",
  packaging = "Mex Packaging",
  advertising = "Mex Advertising",
  foodSupplies = "Mex Food Supplies",
  staffing = "Mex Staffing",
  others = "Mex Others",
  adsType = "Advertisements",
}

export enum TransactionStatus {
  success = "Success",
  failed = "Failed",
  pending = "Pending",
  cancelled = "Cancelled",
}

export enum OrderStatus {
  complete = "Completed",
  merchantCancelled = "Merchant Cancelled",
  failed = "Failed",
}

export enum PayMethod {
  cash = "Cash",
  cashless = "Cashless",
  non = "",
}

export enum OrderPaymentType {
  autoPaid = "Auto-Paid",
  notPaid = "Not Paid",
}

export enum TransactionPaymentType {
  autoPaid = "Auto-Paid",
  manuallyPaid = "Manually paid",
}

export enum TransactionType {
  mpaType = "Manually Paid",
}

export enum MenuDisplayOption {
  category = "CATEGORY",
  department = "DEPARTMENT",
}

export const API_DEFAULT_LIMIT = 50
export const API_MERCHANT_BALANCE_LIMIT = 10

export const ALL_TRANSACTIONS = "all"
export const ALL_ORDERS = "all"

export const PLACEHOLDER_DASH = "--"

export const EMPTY = {}

export const TROY_SUPPORT_LANG = ["id", "en", "ms", "th", "vi", "zh", "zh-hant-tw"]

export const DAILY_SELECTION_LIMIT = 90

export const GKMM_DEPLOY_TIMESTAMP_ML = 1614614400000 // Date and time (GMT): Monday, 1 March 2021 16:00:00
export const GKMM_DEPLOY_TZ = "Asia/Jakarta" // hardcode
export const GKMM_DEPLOY_FORMAT = "DD-MM-YYYY"
